import moduleIntegrityCheck from "~components/shared/module/Module.integrity";
import { ZoneColumnCombo } from "~types/types";
import type { IntegrityStatus } from "~utils/moduleIntegrity";

import type { NewsletterDefaultProps } from "./NewsletterDefault";

const SUPPORTED_RENDERING_LOCATIONS: ZoneColumnCombo[] = [
    ZoneColumnCombo.leftRail,
    ZoneColumnCombo.rightRail,
];

export default function integrityCheck(
    props: NewsletterDefaultProps
): IntegrityStatus {
    const messages: IntegrityStatus = moduleIntegrityCheck(props);

    if (!SUPPORTED_RENDERING_LOCATIONS.includes(props.renderingLocation)) {
        messages.push(
            `Unsupported rendering location: ${props.renderingLocation}`
        );
    }

    if (!props.title) {
        messages.push("Module is missing a title.");
    }

    if (!props.listId) {
        messages.push("Module is missing a listId.");
    }

    return messages;
}
